module.exports = __webpack_public_path__ + "img/moka-qa.c5e66661.png";